import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	thirdPartyLinked: {
		id: 'servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.third-party-linked',
		defaultMessage: 'Your admin has added {value}',
		description: 'Title for the third party connector illustration',
	},
	thirdPartyConnectorDescription: {
		id: 'servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.third-party-connector-description',
		defaultMessage:
			"Your admin has linked {value} folders to this project’s knowledge base. Documents in the linked folders are used to answer your customers' questions when they search on portal or help centers.",
		description: 'Thirdparty connectors illustration description',
	},
});
